export const BB_RACING_WIDGET_CLASS = 'bb-racing-widget';
export const BB_RACING_WIDGET_TABS_CLASS = `${BB_RACING_WIDGET_CLASS}__tabs`;
export const BB_RACING_WIDGET_SCHEDULE_CLASS = `${BB_RACING_WIDGET_CLASS}__schedule`;
export const BB_RACING_WIDGET_RACECARD_FOOTER_CLASS = `${BB_RACING_WIDGET_CLASS}__go-to-event`;
export const BB_RACING_WIDGET_RACECARD_FOOTER_STREAMING_CLASS = `${BB_RACING_WIDGET_RACECARD_FOOTER_CLASS}--streaming`;
export const BB_RACING_WIDGET_RACECARD_FOOTER_GTM = 'view-racecard';
export const BB_RACING_WIDGET_EW_PLUS_ICON_CLASS = 'ew_plus_icon';
export const BB_RACING_WIDGET_DATE_LABEL_CLASS = `${BB_RACING_WIDGET_CLASS}__date-label`;
export const BB_RACING_WIDGET_TOURNAMENT_LABEL_CLASS = `${BB_RACING_WIDGET_CLASS}__tournament-label`;
export const BB_RACING_WIDGET_HEADLINE_ICON_CLASS = `${BB_RACING_WIDGET_CLASS}__headline-icon`;
export const BB_RACING_WIDGET_BET_TICKMARK_CLASS = `${BB_RACING_WIDGET_CLASS}__bet-tickmark`;
export const BB_RACING_WIDGET_FEATURED_CLASS = `${BB_RACING_WIDGET_CLASS}__featured-event`;
export const BB_RACING_WIDGET_TIMEFORM_LABEL_CLASS = `${BB_RACING_WIDGET_CLASS}__timeform-label`;
export const BB_RACING_WIDGET_TIMEFORM_CLASS = `${BB_RACING_WIDGET_CLASS}__timeform`;
export const BB_RACING_WIDGET_COMMENT_CLASS = `${BB_RACING_WIDGET_CLASS}__timeform-comment`;
export const BB_RACING_WIDGET_RACECARD_CLASS = `${BB_RACING_WIDGET_CLASS}__racecard`;
export const BB_RACING_REQUEST_URL = '/sportsbook-req/';
export const BB_RACING_REQUEST_URL_INIT_RACING = `${BB_RACING_REQUEST_URL}initRacing/`;
export const BB_RACING_REQUEST_URL_RACECARD = `${BB_RACING_REQUEST_URL}raceCard/`;
export const BB_RACING_REQUEST_URL_SCHEDULE_RACING = `${BB_RACING_REQUEST_URL}racingSchedule/`;

export const BB_RACING_WIDGET_NAVIGATION_CLASS = 'c-widgetcontainer';

export const BB_RACING_HORSE = 'horse-racing';
export const BB_RACING_GREYHOUND = 'greyhound-racing';
export const BB_RACING_TROTTING = 'trotting';

export const FEATURED_TYPE = 'featured';
export const NEXT_RACES_TYPE = 'next-races';
export const FEATURED_TYPE_INDEX = 0;
export const NEXT_RACES_TYPE_INDEX = 1;
export const RACES_TYPE_MAP = new Map([
    [FEATURED_TYPE_INDEX, FEATURED_TYPE],
    [NEXT_RACES_TYPE_INDEX, NEXT_RACES_TYPE],
]);

export const BB_RACING_WIDGET_BOG_MODIFIER = 'bog';
export const BB_RACING_WIDGET_REGULAR_MODIFIER = 'regular';

export const BB_RACING_WIDGET_RACE_TAB = 'races-tab';
export const BB_RACING_WIDGET_SUFFIX = '-widget';
export const BB_RACING_HOMEPAGE_HEADING = 'racing.next_races_heading';
export const BB_RACING_ACTION_SEE_ALL = 'see-all';

export const WS_HANDLER_COMPONENT_NAME = 'RacingWidget';

export const FEATURED_PAGE = 'featured-page';
export const NEXT_RACES_PAGE = 'next-races-page';
